export class ResetState {
  static readonly type = '@store.resetState';
}
